import { __decorate, __metadata } from "tslib";
//NPM
import { Component, Mixins, Vue, Watch } from "vue-property-decorator";
import Simplebar from "simplebar-vue";
import LiquorTree from "liquor-tree";
import { v4 as uuidv4 } from "uuid";
Vue.use(LiquorTree);
//SYSTEMONE
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { MenuModule } from "@/store/modules/Menu.module";
import { setInteractionMode } from "vee-validate";
import { toaster } from "@/utilities/toaster";
import { AppMenuOrderingRequestModel } from "@/store/models/menu/request/AppMenuOrderingRequest";
import DeleteComponent from "@/components/deleteComponent.vue";
setInteractionMode("passive");
Vue.use(LiquorTree);
Component.registerHooks(["beforeRouteEnter"]);
let MenuManager = /** @class */ (() => {
    let MenuManager = class MenuManager extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.title = "Menu Manager";
            this.showMenuModal = false;
            this.showDeleteMenuModal = false;
            this.aMenuItem = {
                id: null,
                text: "",
                data: {
                    slug: "",
                    icon: "",
                    label: "",
                    pageElementId: null,
                    parentMenuId: null,
                    displayOrder: 0,
                },
                children: [],
            };
            this.options = {
                checkbox: false,
                deletion: false,
                dnd: true,
                filter: {
                    emptyText: "",
                },
            };
            this.filter = null;
            this.addMenuItem = false;
            this.deleteNode = null;
            this.editNode = null;
            this.editMenuItem = false;
            this.modalTitle = "";
            this.flatMenu = [];
            this.rootDisplayOrder = 1;
            this.childDisplayOrder = 1;
            this.showLoading = false;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Developer Tools",
                    href: "#",
                },
                {
                    text: "Menu Manager",
                    active: true,
                },
            ];
        }
        initializeMenuItem(parentId) {
            this.aMenuItem.id = uuidv4();
            this.aMenuItem.text = "";
            this.aMenuItem.data.slug = "";
            this.aMenuItem.data.label = "";
            this.aMenuItem.data.icon = "";
            this.aMenuItem.data.parentMenuId = parentId;
            this.aMenuItem.data.displayOrder = parentId == null ? this.menu.length + 1 : this.menu.find((x) => x.id == parentId.toString()).children.length + 1;
            this.aMenuItem.data.pageElementId = "";
        }
        initializeEditMenuItem(node) {
            this.aMenuItem.id = node.id;
            this.aMenuItem.text = node.text;
            this.aMenuItem.data.pageElementId = node.data.pageElementId;
            this.aMenuItem.data.slug = node.data.slug;
            this.aMenuItem.data.icon = node.data.icon;
            this.aMenuItem.data.label = node.data.label;
            this.aMenuItem.data.parentMenuId = node.data.parentMenuId;
        }
        openMenuModal(node) {
            this.showMenuModal = true;
            if (node !== null) {
                this.parentNode = node;
                this.addMenuItem = true;
                this.editMenuItem = false;
                this.initializeMenuItem(this.parentNode.id);
                this.modalTitle = "Add Menu";
            }
            else {
                this.addMenuItem = false;
                this.editMenuItem = false;
                this.initializeMenuItem(null);
                this.modalTitle = "Add Root Menu";
            }
        }
        // public setFocusToInput() {
        //   let theMenuTextbox = this.$refs["txtMenu"] as HTMLInputElement & {};
        //   theMenuTextbox.focus();
        // }
        closeMenuModal() {
            this.showMenuModal = false;
            this.showLoading = false;
        }
        openEditMenuModal(node, e) {
            this.showMenuModal = true;
            this.addMenuItem = false;
            this.editMenuItem = true;
            this.editNode = node;
            this.initializeEditMenuItem(node);
            this.modalTitle = "Edit Menu";
        }
        openDeleteMenuModal(node) {
            var that = this;
            if (node.children.length > 0) {
                toaster.ShowError("Please delete the child menu(s).");
                return;
            }
            this.showDeleteMenuModal = true;
            this.deleteNode = node;
        }
        closeDeleteMenuModal() {
            this.showDeleteMenuModal = false;
        }
        saveMenuItem() {
            this.validate("newAddMenuObserver").then((response) => {
                if (response) {
                    this.showLoading = true;
                    let theTree = this.$refs.tree;
                    var allExpandedNodes = theTree.find({ state: { expanded: true } }, true);
                    if (this.addMenuItem) {
                        if (this.parentNode.enabled()) {
                            MenuModule.AddMenu(this.aMenuItem).then((response) => {
                                let theTreeAfter = this.$refs.tree;
                                for (let j = 0; j < allExpandedNodes.length; j++) {
                                    theTreeAfter.find({ id: allExpandedNodes[j].id }, true).expand();
                                }
                                this.filter = "";
                                this.closeMenuModal();
                                toaster.ShowApiSuccess(response);
                                MenuModule.GetMenu().then(() => {
                                    this.showLoading = false;
                                });
                            });
                        }
                    }
                    else if (this.editMenuItem) {
                        MenuModule.UpdateMenu(this.aMenuItem).then((response) => {
                            let theTreeAfter = this.$refs.tree;
                            for (let j = 0; j < allExpandedNodes.length; j++) {
                                theTreeAfter.find({ id: allExpandedNodes[j].id }, true).expand();
                            }
                            this.filter = "";
                            this.closeMenuModal();
                            toaster.ShowApiSuccess(response);
                            MenuModule.GetMenu().then(() => {
                                this.showLoading = false;
                            });
                        });
                    }
                    else {
                        MenuModule.AddMenu(this.aMenuItem).then((response) => {
                            let theTreeAfter = this.$refs.tree;
                            for (let j = 0; j < allExpandedNodes.length; j++) {
                                theTreeAfter.find({ id: allExpandedNodes[j].id }, true).expand();
                            }
                            this.filter = "";
                            this.closeMenuModal();
                            toaster.ShowApiSuccess(response);
                            MenuModule.GetMenu().then(() => {
                                this.showLoading = false;
                            });
                        });
                    }
                }
            });
        }
        deleteMenuItem() {
            var that = this;
            this.showLoading = true;
            let theTree = this.$refs.tree;
            var allExpandedNodes = theTree.find({ state: { expanded: true } }, true);
            MenuModule.DeleteMenu(this.deleteNode.id).then((response) => {
                if (response) {
                    let theTreeAfter = this.$refs.tree;
                    for (let j = 0; j < allExpandedNodes.length; j++) {
                        theTreeAfter.find({ id: allExpandedNodes[j].id }, true).expand();
                    }
                    this.filter = "";
                    this.closeDeleteMenuModal();
                    toaster.ShowApiSuccess(response);
                    MenuModule.GetMenu().then(() => {
                        this.showLoading = false;
                    });
                }
            });
        }
        dragStart(node) {
            console.log("Start dragging: " + node.text);
        }
        dragFinish(targetNode, destinationNode, dropPosition) {
            console.log(`Stop dragging: [TARGET]${targetNode.text}`);
            console.log(`Stop dragging: [TARGET]${destinationNode.text}`);
            console.log(`Stop dragging: [TARGET]${dropPosition}`);
            console.log(targetNode);
            console.log(destinationNode);
            var that = this;
            this.flatMenu = [];
            this.rootDisplayOrder = 1;
            this.childDisplayOrder = 1;
            // Read all the Menu Items from the Tree and Get it into a Flat Menu Array
            let theTree = this.$refs.tree;
            let len = theTree.tree.model.length;
            for (let i = 0; i < len; i++) {
                var currentNode = theTree.find({ id: theTree.tree.model[i].id }, true).select();
                this.convertMenuTreeToList(currentNode);
            }
            console.log(this.rootDisplayOrder);
            console.log(this.childDisplayOrder);
            var allExpandedNodes = theTree.find({ state: { expanded: true } }, true);
            var allTreeNodes = theTree.findAll({ data: { parentMenuId: null } });
            console.log(allTreeNodes);
            var request = new AppMenuOrderingRequestModel();
            request.id = targetNode.id;
            if (dropPosition == "drag-on") {
                request.displayOrder = allTreeNodes.find((x) => x.id == destinationNode.id).children.indexOf(targetNode) + 1;
                console.log(request.displayOrder);
                request.parentId = destinationNode.id;
            }
            else {
                if (destinationNode.data.parentMenuId == null) {
                    request.displayOrder = allTreeNodes.indexOf(destinationNode) + (dropPosition == "drag-above" ? 0 : 2);
                    console.log(request.displayOrder);
                }
                else {
                    request.displayOrder = allTreeNodes.find((x) => x.id == destinationNode.data.parentMenuId).children.indexOf(targetNode) + 1;
                    console.log(request.displayOrder);
                }
                request.parentId = destinationNode.data.parentMenuId;
            }
            // if (dropPosition == "drag-above") {
            //   request.displayOrder = destinationNode.data.displayOrder;
            // } else {
            //   request.displayOrder = destinationNode.data.displayOrder + 1;
            // }
            console.log(request);
            // if(dropPosition == "drag-on"){
            //   request.parentId = destinationNode.id;
            // }
            MenuModule.UpdateMenuOrdering(request).then((request) => {
                MenuModule.GetMenu();
            });
        }
        convertMenuTreeToList(root) {
            var stack = [];
            stack.push(root[0]);
            while (stack.length !== 0) {
                var node = stack.pop();
                if (node.children.length === 0) {
                    this.addToFlatMenu(node);
                }
                else {
                    this.addToFlatMenu(node);
                    this.childDisplayOrder = 1;
                    for (var i = node.children.length - 1; i >= 0; i--) {
                        stack.push(node.children[i]);
                    }
                }
            }
        }
        addToFlatMenu(node) {
            var aMenu;
            aMenu = {
                id: node.id,
                data: {
                    parentMenuId: node.parent !== null ? node.parent.id : node.parent,
                    slug: "",
                    icon: "",
                    label: "",
                    pageElementId: "",
                    displayOrder: 0,
                },
                text: node.data.text,
                children: [],
            };
            this.flatMenu.push(aMenu);
            this.childDisplayOrder = this.childDisplayOrder + 1;
        }
        // public validate(): Promise<boolean> {
        //   let form = this.$refs.observer as Vue & {
        //     validate: () => Promise<boolean>;
        //   };
        //   return form.validate().then((valid) => {
        //     if (!valid) {
        //       return false;
        //     } else {
        //       return true;
        //     }
        //   });
        // }
        get menu() {
            return MenuModule.menus;
        }
        get requiredRule() {
            return "required|isNot:''";
        }
        // refreshes the tree
        menuChanged() {
            let theTree = this.$refs.tree;
            theTree.tree.setModel(this.menu);
        }
        // get Menus() {
        // 	return MenuModule.menus;
        // }
        get pages() {
            return MenuModule.pages;
        }
        // get sortedFilteredRole() {
        // 	return _.sortBy(this.pages, o => o.value);
        // }
        created() {
            this.showLoading = true;
            MenuModule.GetMenu().then(() => {
                this.showLoading = false;
            });
        }
        destroyed() { }
    };
    __decorate([
        Watch("menu"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Object)
    ], MenuManager.prototype, "menuChanged", null);
    MenuManager = __decorate([
        Component({
            name: "MenuManager",
            components: {
                Layout,
                PageHeader,
                Loader,
                Simplebar,
                DeleteComponent,
            },
        })
    ], MenuManager);
    return MenuManager;
})();
export default MenuManager;
